export type CompareTab = {
  type: 'compare';
  dashboardId: string;
  routeParams: {
    dash: string;
    tab?: string;
    dashboardId?: string;
  };
  label: string;
  description?: string;
  enabledInArchive?: boolean;
};

const compareTabs: CompareTab[] = [
  {
    type: 'compare',
    label: 'All runs',
    dashboardId: 'table',
    routeParams: { tab: 'table', dash: 'table' },
    enabledInArchive: true,
  },
  {
    type: 'compare',
    label: 'Charts',
    dashboardId: 'charts',
    routeParams: { dash: 'charts' },
  },
  {
    type: 'compare',
    label: 'Side-by-side',
    dashboardId: 'leaderboard',
    routeParams: { dash: 'leaderboard' },
  },
  {
    type: 'compare',
    label: 'Dashboards',
    dashboardId: 'dashboard',
    routeParams: { dash: 'dashboard' },
  },
];

/* NOTE: Registering new tab please update keyboard shortcut in KeyboardShortcutsModal.tsx */
export const compareDefaultTabs = compareTabs;
